/*
 * DIVSN Bundle-Sync (strikt)
 * Bundle-Codes (BUNDLE-2-*, BUNDLE-3-*, BUNDLE-VERSAND) gelten nur, solange der Warenkorb genau dem
 * gewaehlten Bundle entspricht:
 *  - 2er-Code: genau 2 Teile mit Zeilen-Eigenschaft _Bundle (vom Bundle-Block gesetzt)
 *  - 3er-Code: genau 3 Teile mit _Bundle
 *  - keine weiteren Hoodies oder T-Shirts ausserhalb des Bundles
 * Sonderfall 3er -> 2er: Wird aus einem 3er-Bundle ein Teil entfernt (und es sind sonst keine Hoodies/Shirts
 * im Warenkorb), wird das Bundle automatisch zum 2er-Bundle (passender BUNDLE-2-Code plus BUNDLE-VERSAND).
 * Sonst (2er verliert ein Teil, Menge erhoeht, Teil ergaenzt) werden alle Bundle-Codes entfernt.
 * Der Kunde waehlt das Bundle dann auf der Produktseite neu.
 * Aendert der Kunde den Warenkorb (cart/change), wird die Korrektur direkt in dieselbe Antwort eingebaut,
 * inklusive neu gerenderter Sections. Die Seite laedt dadurch nicht neu, Summe, Versand und Rabatt stimmen sofort.
 * Nur beim Laden der Warenkorb-Seite und nach cart/update (Rabattfeld) bleibt ein Neuladen als Reserve.
 * Das Rabatt-Feld im Warenkorb zeigt BUNDLE-VERSAND nicht an und wuerde den Code beim Eingeben eines
 * weiteren Codes verlieren. Dieses Skript haengt BUNDLE-VERSAND deshalb an, solange ein 2er-Code aktiv ist.
 */
(function () {
  if (window.__divsnBundleSync) return;
  window.__divsnBundleSync = true;

  var R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SHIP = 'BUNDLE-VERSAND';
  var TYPE_H = 'Hoodie';
  var TYPE_S = 'T-Shirt';
  var SHIP_RE = /^BUNDLE-2-/i;
  var ANY_RE = /^BUNDLE-/i;
  var FLAG = 'divsnBundleLost';
  var CODES2 = ['BUNDLE-2-SHIRTS', 'BUNDLE-2-MIX', 'BUNDLE-2-HOODIES'];
  var busy = false;
  var origFetch = window.fetch.bind(window);

  function isCartChangeOnly(url) {
    return /\/cart\/change(\.js)?(\?|$)/.test(String(url || ''));
  }

  function isCartUpdate(url) {
    return /\/cart\/update(\.js)?(\?|$)/.test(String(url || ''));
  }

  function withShip(list) {
    var codes = list.filter(function (c) { return c; });
    var has2 = codes.some(function (c) { return SHIP_RE.test(c); });
    var hasShip = codes.some(function (c) { return c.toUpperCase() === SHIP; });
    if (has2 && !hasShip) codes.push(SHIP);
    if (!has2 && hasShip) codes = codes.filter(function (c) { return c.toUpperCase() !== SHIP; });
    return codes;
  }

  function patchBody(init) {
    if (!init || typeof init.body !== 'string') return init;
    try {
      var data = JSON.parse(init.body);
      if (typeof data.discount !== 'string') return init;
      var fixed = withShip(data.discount.split(',').map(function (c) { return c.trim(); })).join(',');
      if (fixed === data.discount) return init;
      data.discount = fixed;
      var copy = {};
      for (var k in init) copy[k] = init[k];
      copy.body = JSON.stringify(data);
      return copy;
    } catch (e) {
      return init;
    }
  }

  function showMsg(text) {
    var n = document.createElement('div');
    n.setAttribute('role', 'status');
    n.textContent = text;
    n.style.cssText = 'position:fixed;left:16px;right:16px;bottom:16px;z-index:2147483000;max-width:440px;margin:0 auto;padding:14px 16px;background:#0b0b0b;color:#fff;font-size:13px;line-height:1.4;text-align:center;box-shadow:0 4px 20px rgba(0,0,0,.3)';
    document.body.appendChild(n);
    setTimeout(function () { if (n.parentNode) n.parentNode.removeChild(n); }, 9000);
  }

  function noticeText(flag) {
    return flag === '2'
      ? 'Dein 3er-Bundle ist jetzt ein 2er-Bundle. Der Rabatt wurde angepasst.'
      : 'Dein Warenkorb passt nicht mehr zum Bundle, der Bundle-Rabatt ist entfernt. Wähle das Bundle auf der Produktseite neu aus, um ihn zu behalten.';
  }

  function showNotice() {
    var flag = null;
    try { flag = sessionStorage.getItem(FLAG); sessionStorage.removeItem(FLAG); } catch (e) {}
    if (flag) showMsg(noticeText(flag));
  }

  function post(path, body) {
    return origFetch(R + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function withExtra(body, extra) {
    if (extra) for (var k in extra) body[k] = extra[k];
    return body;
  }

  // Alle Bundle-Codes und Bundle-Attribute entfernen. Liefert die Antwort von cart/update.js (inkl. Sections).
  function removeAll(codes, extra) {
    var kept = codes.filter(function (c) { return !ANY_RE.test(c); });
    return post('cart/update.js', withExtra({ discount: kept.join(','), attributes: { Bundle: '', 'Bundle-ID': '' } }, extra))
      .then(function (r) { if (!r.ok) throw new Error('update'); return r.json(); })
      .then(function (json) { return { json: json, flag: '1' }; });
  }

  // 3er-Bundle mit 2 uebrigen Teilen: Zeilen-Eigenschaft auf '2 Stuecke' setzen, dann Codes tauschen.
  function toTwo(cart, codes, extra) {
    var next = null;
    (cart.items || []).forEach(function (it) {
      if (!next && it.properties && it.properties._Bundle === '3 Stücke') next = it;
    });
    if (next) {
      var props = {};
      for (var k in next.properties) props[k] = next.properties[k];
      props._Bundle = '2 Stücke';
      return post('cart/change.js', { id: next.key, quantity: next.quantity, properties: props })
        .then(function (r) { if (!r.ok) throw new Error('change'); return r.json(); })
        .then(function (c) { return toTwo(c, codes, extra); });
    }
    var hoodies = 0;
    (cart.items || []).forEach(function (it) {
      if (it.properties && it.properties._Bundle && it.product_type === TYPE_H) hoodies += it.quantity;
    });
    var code2 = CODES2[Math.min(hoodies, 2)];
    var kept = codes.filter(function (c) { return !ANY_RE.test(c); });
    kept.push(code2, SHIP);
    return post('cart/update.js', withExtra({ discount: kept.join(','), attributes: { Bundle: '2 Stücke' } }, extra))
      .then(function (r) { if (!r.ok) throw new Error('update'); return r.json(); })
      .then(function (c) {
        var ok = (c.discount_codes || []).some(function (x) { return x.code === code2 && x.applicable; });
        if (!ok) throw new Error('code');
        return { json: c, flag: '2' };
      });
  }

  // Entscheidet, ob der Warenkorb zum Bundle-Code passt. Liefert null (alles gut), 'two' oder 'remove'.
  function decide(cart, codes) {
    var has2 = codes.some(function (c) { return SHIP_RE.test(c); });
    var has3 = codes.some(function (c) { return /^BUNDLE-3-/i.test(c); });
    var hasShip = codes.some(function (c) { return c.toUpperCase() === SHIP; });
    if (!has2 && !has3 && !hasShip) return null;

    var qty = 0, other = 0;
    (cart.items || []).forEach(function (it) {
      var isBundle = it.properties && it.properties._Bundle;
      var eligible = it.product_type === TYPE_H || it.product_type === TYPE_S;
      if (isBundle) qty += it.quantity;
      else if (eligible) other += it.quantity;
    });

    var valid = other === 0 && ((has2 && !has3 && qty === 2) || (has3 && !has2 && qty === 3));
    if (valid) return null;
    if (other === 0 && has3 && !has2 && qty === 2) return 'two';
    return 'remove';
  }

  // Korrigiert den Warenkorb. Liefert null (nichts zu tun) oder { json, flag } mit der korrigierten Antwort.
  function fix(cart, extra) {
    var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
    var action = decide(cart, codes);
    if (!action) return Promise.resolve(null);
    if (action === 'two') {
      return toTwo(cart, codes, extra).catch(function () { return removeAll(codes, extra); });
    }
    return removeAll(codes, extra);
  }

  // Reserve: Seitenaufruf der Warenkorb-Seite und cart/update (Rabattfeld). Hier bleibt ein Neuladen.
  function sync() {
    if (busy) return;
    busy = true;
    origFetch(R + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return fix(cart, null); })
      .then(function (out) {
        if (!out) return;
        try { sessionStorage.setItem(FLAG, out.flag); } catch (e) {}
        location.reload();
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function extraFrom(init) {
    try {
      var data = JSON.parse(init.body);
      var extra = {};
      if (data.sections) extra.sections = data.sections;
      if (data.sections_url) extra.sections_url = data.sections_url;
      return extra.sections ? extra : null;
    } catch (e) {
      return null;
    }
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url);
    if (isCartUpdate(url)) init = patchBody(init);

    if (isCartChangeOnly(url) && !busy) {
      var extra = init && typeof init.body === 'string' ? extraFrom(init) : null;
      return origFetch(input, init).then(function (resp) {
        if (!resp || !resp.ok) return resp;
        return resp.clone().json().then(function (cart) {
          if (!cart || !cart.items) return resp;
          busy = true;
          return fix(cart, extra).then(function (out) {
            busy = false;
            if (!out) return resp;
            showMsg(noticeText(out.flag));
            return new Response(JSON.stringify(out.json), { status: 200, headers: { 'Content-Type': 'application/json' } });
          }).catch(function () { busy = false; return resp; });
        }).catch(function () { return resp; });
      });
    }

    var p = origFetch(input, init);
    if (isCartUpdate(url) && !busy) {
      p.then(function (r) { if (r && r.ok) setTimeout(sync, 150); }).catch(function () {});
    }
    return p;
  };

  function start() {
    showNotice();
    if (/\/cart\/?$/.test(location.pathname)) sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
